import { formatDateTimeInTz, formatLocalDateInTz } from '../../../utils/timezone';
import type { DespatchOrder, NurseryLoadStatus } from '../../../types/nursery';

/** "1 Jun 2027 to 31 Jul 2027", "By 31 Jul 2027", a collection time, or null. */
export function despatchWhen(o: Pick<DespatchOrder, 'despatch_method' | 'despatch_from' | 'despatch_by' | 'requested_delivery_date' | 'collection_at'>, tz: string): string | null {
  if (o.despatch_method === 'collection' && o.collection_at) return `Collect ${formatDateTimeInTz(o.collection_at, tz)}`;
  const from = o.despatch_from ? formatLocalDateInTz(o.despatch_from, tz) : null;
  const by = o.despatch_by ? formatLocalDateInTz(o.despatch_by, tz) : null;
  if (from && by) return `${from} to ${by}`;
  if (by) return `By ${by}`;
  if (from) return `From ${from}`;
  if (o.requested_delivery_date) return `Requested ${formatLocalDateInTz(o.requested_delivery_date, tz)}`;
  return null;
}

/** First line of an order's delivery address snapshot. */
export function addressLine(o: Pick<DespatchOrder, 'delivery_address'>): string | null {
  return o.delivery_address ? o.delivery_address.split('\n')[0] : null;
}

export const LOAD_STATUS_LABELS: Record<NurseryLoadStatus, string> = {
  planning: 'Planning',
  released: 'Released to pickers',
  picking: 'Picking',
  loaded: 'Loaded',
  despatched: 'Despatched',
  cancelled: 'Cancelled',
};
